import React, { useEffect } from "react";
import IndustryChart from "./chart";
import { backgroundColors } from "./utils/backgroundColors";
import styles from "./style.module.scss";
import useDashboardStore, {
  fetchIndustriesData,
} from "../../../../stores/dashboard";
import SkeletonLoader from "../../../../components/skeleton-loader";
import IndustriesEmptyIcon from "../../../../assets/svg/icons/common/IndustriesEmptyIcon";

const Industries = () => {
  const industriesData = useDashboardStore((s) => s.industriesData);
  const industriesDataLoading = useDashboardStore(
    (s) => s.industriesDataLoading,
  );

  const filterDataStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterDataEndDate = useDashboardStore((s) => s.filterData.endDate);
  const filterUser = useDashboardStore((s) => s.filterData.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterData.filterOrg);

  useEffect(() => {
    const abortController = new AbortController();
    fetchIndustriesData(abortController);

    return () => {
      abortController.abort();
    };
  }, [filterDataStartDate, filterDataEndDate, filterUser, filterOrg]);

  return (
    <div className={styles.industries}>
      <div className={styles.industriesHeader}>
        <p className={styles.industriesHeaderTitle}>Industries (MCC)</p>
        <p className={styles.industriesHeaderSubtitle}>
          {filterDataStartDate} - {filterDataEndDate}
        </p>
      </div>

      {industriesDataLoading && (
        <>
          <div className={styles.industriesContent}>
            <SkeletonLoader
              variant="circular"
              height={"229px"}
              width={"229px"}
            />
          </div>
          <div className={styles.industriesFooter}>
            {Array.from({ length: 12 }).map((_, index) => (
              <SkeletonLoader
                variant="rectangular"
                height={"16px"}
                width={"36px"}
                key={`industries-footer-${index}`}
                style={{
                  borderRadius: "8px",
                }}
              />
            ))}
          </div>
        </>
      )}

      {!industriesDataLoading && (
        <>
          {industriesData.length > 0 ? (
            <>
              <div className={styles.industriesContent}>
                <IndustryChart data={industriesData} />
              </div>

              <div className={styles.industriesFooter}>
                {!industriesDataLoading &&
                  industriesData &&
                  industriesData.length > 0 &&
                  industriesData.map((item, index) => (
                    <div
                      className={styles.industriesFooterItem}
                      key={`mcc-item-${item.mcc}`}
                    >
                      <span
                        className={styles.colorDot}
                        style={{ backgroundColor: backgroundColors[index] }}
                      ></span>
                      <span className={styles.industryName}>{item.mcc}</span>
                    </div>
                  ))}
              </div>
            </>
          ) : (
            <div className={styles.emptyContainer}>
              <div className={styles.iconBox}>
                <IndustriesEmptyIcon />
              </div>

              <p className={styles.emptyTitle}>
                This chart will display the sales volume and number of MIDs by
                industry (MCC)
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Industries;
